import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ContentContainerModule } from '@morningstar/shared/ui-kit/content-container';
import { CardContainerModule } from '@morningstar/wsg/ui-kit/card-container';
import { AngularMaterialModule } from '@morningstar/shared/ui-kit/angular-material';
import { GenericDeleteDialogModule } from '@morningstar/shared/ui-kit/generic-delete-dialog';
import { HelpVideoIconModule } from '@morningstar/wsg/ui-kit/help-video-icon';
import { EmptyComponent } from './empty/empty.component';
import { FilterModule } from '@morningstar/shared/ui-kit/filter';
import { LoadingPageComponent } from './loading-page/loading-page.component';
import { AfterViewInitDirective } from './directives/after-view-init.directive';
import { ValidateRouteDirective } from './directives/validate-route.directive';
import { GenericLandingPageComponent } from './generic-landing-page/generic-landing-page.component';
import { RouterModule } from '@angular/router';
import { HeadingModule } from '@morningstar/shared/ui-kit/heading';
import { ReportExplanationIconModule } from '@morningstar/wsg/ui-kit/report-explanation-icon';

@NgModule({
  imports: [
    CommonModule,
    AngularMaterialModule,
    ContentContainerModule,
    CardContainerModule,
    FlexLayoutModule,
    FilterModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    HelpVideoIconModule,
    GenericDeleteDialogModule,
    HeadingModule,
    ReportExplanationIconModule
  ],
  declarations: [
    ValidateRouteDirective,
    AfterViewInitDirective,
    EmptyComponent,
    GenericLandingPageComponent,
    LoadingPageComponent
  ],
  exports: [
    AngularMaterialModule,
    CardContainerModule,
    ContentContainerModule,
    CommonModule,
    EmptyComponent,
    FilterModule,
    FlexLayoutModule,
    GenericDeleteDialogModule,
    GenericLandingPageComponent,
    LoadingPageComponent,
    ReactiveFormsModule,
    AfterViewInitDirective,
    HelpVideoIconModule,
    ValidateRouteDirective,
    HeadingModule,
    ReportExplanationIconModule
  ]
})
export class WsgSharedModule {}
